import { TrendingUp, Clock, MessageCircle, Sparkles, LucideIcon } from "lucide-react";
import { memo } from "react";

interface Benefit {
  icon: LucideIcon;
  title: string;
  description: string;
}

const benefits: Benefit[] = [
  {
    icon: TrendingUp,
    title: "Aumente suas Vendas",
    description: "Clientes que veem modelos vestindo as peças têm 40% mais chance de comprar."
  },
  {
    icon: Clock,
    title: "Economize Tempo",
    description: "Gere imagens profissionais em segundos, sem precisar de sessões de fotos."
  },
  {
    icon: MessageCircle,
    title: "Venda pelo WhatsApp",
    description: "Compartilhe seu catálogo e receba pedidos diretamente no WhatsApp."
  },
  {
    icon: Sparkles,
    title: "IA para Moda Feminina",
    description: "Tecnologia treinada especificamente para roupas e acessórios femininos."
  }
];

const BenefitCard = memo(function BenefitCard({ benefit }: { benefit: Benefit }) {
  const Icon = benefit.icon;
  return (
    <div className="group p-4 bg-card rounded-xl border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-glow hover:-translate-y-1">
      <div className="w-10 h-10 rounded-lg bg-accent flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
        <Icon className="w-5 h-5 text-primary" />
      </div>
      <h3 className="text-base font-semibold mb-1">{benefit.title}</h3>
      <p className="text-sm text-muted-foreground">{benefit.description}</p>
    </div>
  );
});

export const BenefitsSection = memo(function BenefitsSection() {
  return (
    <section id="beneficios" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Por que usar o <span className="text-gradient">VesteIA</span>?
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Tudo que você precisa para transformar sua loja de moda e vender mais
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {benefits.map((benefit, index) => (
            <BenefitCard key={index} benefit={benefit} />
          ))}
        </div>
      </div>
    </section>
  );
});
